<template>
    <div class="b-white p-2 rounded shadow-sm mb-3">
        <div class="_profile d-flex align-items-center mb-2">
            <img :src="avatar" alt="" height="50" width="50" class="rounded-circle">
            <div class="__name_user_comment ml-3">
                {{this.name}} {{this.lname ? this.lname : ''}}
                <RatingComment :star="stars"/>
            </div>
        </div>
        <div class="__comment border-top py-3">
            {{comment}}
        </div>
        <small class="__published">{{created_at | timeDate}}</small>
    </div>
</template>
<style scoped>
    .__name_user_comment{
        font-size: 16px;
    }
    .__comment{
        font-size: 13px;
    }
</style>
<script>
import RatingComment from './RatingComment'
export default {
    components:{
        'RatingComment': RatingComment
    },
    props:{
        avatar: String,
        name: String,
        lname: String,
        comment: String,
        stars: Number,
        created_at: String
    },
    data() {
        return {
            
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/#public/curse/components/view/Comment.vue